export const initialSettingsViewState: SettingsViewState = {
  tempBudgetFinishDate: 0,
};
